import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import { InputValue, BoolInputValue, TextInputValue, NumericInputValue, SelectInputValue, DateInputValue, DocumentsInputValue } from '@taxfyle/api-internal/internal/question_input_value_pb';
import { numberToDecimal, decimalToNumber } from '../../utils/grpcUtil';
var QuestionType = {
  Bool: 'BOOL',
  Text: 'TEXT',
  Numeric: 'NUMERIC',
  DateTime: 'DATE_TIME',
  Select: 'SELECT',
  Documents: 'DOCUMENTS',
  Breaker: 'BREAKER'
};
var mapper = {
  toDto: function toDto(question) {
    var inputValue = new InputValue();
    switch (question.type) {
      case 'BOOL':
        {
          inputValue.setBoolValue(new BoolInputValue().setValue(question.answer));
          break;
        }
      case 'TEXT':
        inputValue.setTextValue(new TextInputValue().setValue(question.answer));
        break;
      case 'NUMERIC':
        inputValue.setNumericValue(new NumericInputValue().setValue(numberToDecimal(question.answer)));
        break;
      case 'SELECT':
        if (question.multi) {
          inputValue.setSelectValue(new SelectInputValue().setMulti(new SelectInputValue.Multi().setSelectedIdsList(question.answer)));
        } else {
          inputValue.setSelectValue(new SelectInputValue().setSingle(new SelectInputValue.Single().setSelectedId(question.answer)));
        }
        break;
      case 'DATE_TIME':
        {
          var value = new Timestamp();
          value.fromDate(question.answer);
          inputValue.setDateValue(new DateInputValue().setValue(value));
          break;
        }
      case 'DOCUMENTS':
        {
          var documentsList = question.answer.map(function (answer) {
            return new DocumentsInputValue.DocumentsAnswerEntry().setId(answer.id).setLinkedDocumentId(answer.document_id);
          });
          inputValue.setDocumentsValue(new DocumentsInputValue().setSelectedDocumentsList(documentsList));
          break;
        }
      default:
        throw new Error('Question type is not supported.');
    }
    return inputValue;
  },
  fromDto: function fromDto(inputValue) {
    var _inputValue$getDescri, _inputValue$getAnswer, _inputValue$getAnswer2, _inputValue$getAnswer3, _inputValue$getAnswer4, _inputValue$getAnswer7, _inputValue$getAnswer8, _inputValue$getAnswer9, _inputValue$getMulti, _inputValue$getAnswer16, _inputValue$getAnswer17;
    var result = {
      id: inputValue.getId(),
      question: inputValue.getQuestion(),
      description: (_inputValue$getDescri = inputValue.getDescription()) === null || _inputValue$getDescri === void 0 ? void 0 : _inputValue$getDescri.getValue(),
      type: QuestionType[inputValue.getType()]
    };
    switch (result.type) {
      case 'BOOL':
        result.answer = (_inputValue$getAnswer = inputValue.getAnswer()) === null || _inputValue$getAnswer === void 0 ? void 0 : (_inputValue$getAnswer2 = _inputValue$getAnswer.getBoolValue()) === null || _inputValue$getAnswer2 === void 0 ? void 0 : _inputValue$getAnswer2.getValue();
        break;
      case 'TEXT':
        result.answer = (_inputValue$getAnswer3 = inputValue.getAnswer()) === null || _inputValue$getAnswer3 === void 0 ? void 0 : (_inputValue$getAnswer4 = _inputValue$getAnswer3.getTextValue()) === null || _inputValue$getAnswer4 === void 0 ? void 0 : _inputValue$getAnswer4.getValue();
        break;
      case 'NUMERIC':
        {
          var _inputValue$getFormat, _inputValue$getFormat2, _inputValue$getAnswer5, _inputValue$getAnswer6;
          result.format = {
            type: (_inputValue$getFormat = inputValue.getFormat()) === null || _inputValue$getFormat === void 0 ? void 0 : _inputValue$getFormat.getType(),
            places: (_inputValue$getFormat2 = inputValue.getFormat()) === null || _inputValue$getFormat2 === void 0 ? void 0 : _inputValue$getFormat2.getPlaces()
          };
          var decimalValue = (_inputValue$getAnswer5 = inputValue.getAnswer()) === null || _inputValue$getAnswer5 === void 0 ? void 0 : (_inputValue$getAnswer6 = _inputValue$getAnswer5.getNumericValue()) === null || _inputValue$getAnswer6 === void 0 ? void 0 : _inputValue$getAnswer6.getValue();
          if (decimalValue) {
            result.answer = decimalToNumber(decimalValue);
          }
          break;
        }
      case 'DATE_TIME':
        result.collect_time = inputValue.getCollectTime();
        result.disallow_future = inputValue.getDisallowFuture();
        result.disallow_past = inputValue.getDisallowPast();
        result.answer = (_inputValue$getAnswer7 = inputValue.getAnswer()) === null || _inputValue$getAnswer7 === void 0 ? void 0 : (_inputValue$getAnswer8 = _inputValue$getAnswer7.getDateValue()) === null || _inputValue$getAnswer8 === void 0 ? void 0 : (_inputValue$getAnswer9 = _inputValue$getAnswer8.getValue()) === null || _inputValue$getAnswer9 === void 0 ? void 0 : _inputValue$getAnswer9.toDate();
        break;
      case 'SELECT':
        result.options = inputValue.getOptionsList().map(function (option) {
          return {
            id: option.getId(),
            text: option.getText()
          };
        });
        result.multi = (_inputValue$getMulti = inputValue.getMulti()) === null || _inputValue$getMulti === void 0 ? void 0 : _inputValue$getMulti.getValue();
        if (result.multi) {
          var _inputValue$getAnswer10, _inputValue$getAnswer11, _inputValue$getAnswer12;
          result.answer = (_inputValue$getAnswer10 = inputValue.getAnswer()) === null || _inputValue$getAnswer10 === void 0 ? void 0 : (_inputValue$getAnswer11 = _inputValue$getAnswer10.getSelectValue()) === null || _inputValue$getAnswer11 === void 0 ? void 0 : (_inputValue$getAnswer12 = _inputValue$getAnswer11.getMulti()) === null || _inputValue$getAnswer12 === void 0 ? void 0 : _inputValue$getAnswer12.getSelectedIdsList();
        } else {
          var _inputValue$getAnswer13, _inputValue$getAnswer14, _inputValue$getAnswer15;
          result.answer = (_inputValue$getAnswer13 = inputValue.getAnswer()) === null || _inputValue$getAnswer13 === void 0 ? void 0 : (_inputValue$getAnswer14 = _inputValue$getAnswer13.getSelectValue()) === null || _inputValue$getAnswer14 === void 0 ? void 0 : (_inputValue$getAnswer15 = _inputValue$getAnswer14.getSingle()) === null || _inputValue$getAnswer15 === void 0 ? void 0 : _inputValue$getAnswer15.getSelectedId();
        }
        break;
      case 'DOCUMENTS':
        result.options = inputValue.getOptionsList().map(function (option) {
          return {
            id: option.getId(),
            text: option.getText()
          };
        });
        result.answer = (_inputValue$getAnswer16 = inputValue.getAnswer()) === null || _inputValue$getAnswer16 === void 0 ? void 0 : (_inputValue$getAnswer17 = _inputValue$getAnswer16.getDocumentsValue()) === null || _inputValue$getAnswer17 === void 0 ? void 0 : _inputValue$getAnswer17.getSelectedDocumentsList().map(function (document) {
          return {
            id: document.getId(),
            document_id: document.getLinkedDocumentId()
          };
        });
        break;
    }
    return result;
  }
};
export default mapper;
//# sourceMappingURL=QuestionMapper.js.map
